/* AB test library - https://42.huffpost.net/index.php/AB_Tests
 *
 * Register an AB (or ABΓ∆whatever) test at http://production-statsv3-letmein-01.use1.huffpo.net/
 * Add it to the `tests` assignment below, for instance:
 *   var tests = {
 *     headlineShare: {id: 24, variants: {true: 1, false: 2}},
 *     fontSize: {id: 25, variants: {"60px": 1, "80px": 2, "100px": 3}},
 *   }
 * where the key name is what another JS file refers to the test by,
 * where the keys of the variants are the states of the test, and
 * where the values of the variants are the actual variant ids
 *
 * Then elsewhere set the state of the AB test, for instance:
 *   MW.modules.AB.set("headlineShare", false);
 *   MW.modules.AB.set("fontSize", "80px");
 * An AB test that's defined in the `tests` var doesn't need to ever be set.
 * All AB tests that have been set with a value will get stringified and added
 * as a query param to dataLayer requests. To avoid a race condition, set the
 * state of an AB test as the lib that uses it gets evaluated, rather than after
 * the page loads.
 *
 * To get a simple randomized test state, without caring about where it comes
 * from, use `sample(name)`, for instance:
 *   var abTestHeadline = MW.modules.AB.sample("headlineShare");
 * A second param is used as the default value when local storage is disabled.
 * (If left out, it will pick a random result anyway.)
 *
 * AB tests should always be reported in the query param "abTest" in the format
 * "#{testId}:#{variantId}", comma separated, for instance:
 *   "abTest=24:2,25:A2"
 *
 */
(function() {
  var tests = {
    headlineShare: {id: 24, variants: {true: 1, false: 2}},
    gravitySponsored: {id: 29, variants: {"inSplash": 1, "mixed": 2}},
    readMore: {id: 31, variants: {true: 1, false: 2}},
    gravityPresent: {id: 32, variants: {true: 1, false: 2}},
    socialCounts: {id: 38, variants: {"visible": 1, "hidden": 2}}
  };
  var testStrings = [];
  var storage = MW.modules.storage;
  var sessionStorage = {};

  MW.modules.AB = {
    set: setTestState,
    testMap: function() {
      // multiple AB tests are return in the abTest query param,
      // separated by commas. Tracky calls this when including AB test
      // data in datalayer's query params.
      return testStrings;
    },
    sample: function(name, defaultVal) {
      var val = defaultVal;
      if (sessionStorage[name]) {
        return sessionStorage[name];
      }
      if (storage.enabled || defaultVal === undefined) {
        var key = "abTest-"+name;
        var saved = storage.get(key);
        if (saved && Date.now() < saved.date + oneWeek) {
          val = saved.value;
        } else {
          val = pickRandomState(name);
        }
      }
      setTestState(name, val);
      return val;
    }
  };

  function setTestState(name, value) {
    if (tests[name]) {
      var id = tests[name].id;
      var variant = tests[name].variants[value];
      if (variant === undefined) { console.error("Could not find AB test variant for value", value); }

      // Tests are stringified as "#{id}:#{variant}" (both are numbers)
      testStrings.push([id, variant].join(":"));
      sessionStorage[name] = value;
      storage.set("abTest-"+name, {value: value, date: Date.now()});
      if (MW.devMode) { console.log("AB test", name, "set to", value); }
    } else {
      console.error("Could not find AB test", name);
    }
  }

  function pickRandomState(name) {
    var keys = Object.keys(tests[name].variants);
    return keys[Math.floor(Math.random() * keys.length)];
  }

  var oneWeek = 1000 * 60 * 60 * 24 * 7;
})();